module.exports = __webpack_public_path__ + "static/media/x.ad44d45d.png";